export const organizer = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Miles Republic',
  url: 'https://www.milesrepublic.fr/',
  logo: 'https://milesrepublic.fr/logo-xxxxxxxxx.png',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Lille, France',
    postalCode: '59000',
    streetAddress: '27 rue du Général de Gaulle'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+33-902-650-340',
    contactType: 'customer service'
  },
  sameAs: ['https://www.facebook.com/peyce/', 'https://twitter.com/peyce']
}
